'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * HYDRA ACTIONS
 */

var ACTION_TYPE_PREFIX = '@@hydra/';

var QUEUE_RECORD_TEST = exports.QUEUE_RECORD_TEST = ACTION_TYPE_PREFIX + 'QUEUE_RECORD_TEST';
var RECEIVE_ACTIVE_TESTS = exports.RECEIVE_ACTIVE_TESTS = ACTION_TYPE_PREFIX + 'RECEIVE_ACTIVE_TESTS';
var RECEIVE_TEST_ASSIGNMENT = exports.RECEIVE_TEST_ASSIGNMENT = ACTION_TYPE_PREFIX + 'RECEIVE_TEST_ASSIGNMENT';
var RECEIVE_TEST_ASSIGNMENTS = exports.RECEIVE_TEST_ASSIGNMENTS = ACTION_TYPE_PREFIX + 'RECEIVE_TEST_ASSIGNMENTS';

/**
 * HYDRA TREATMENTS
 */

var HYDRA_TREATMENT_APPLIED = exports.HYDRA_TREATMENT_APPLIED = 'APPLIED';
var HYDRA_TREATMENT_REASSIGNED = exports.HYDRA_TREATMENT_REASSIGNED = 'REASSIGNED';
var HYDRA_TREATMENT_ASSIGNED = exports.HYDRA_TREATMENT_ASSIGNED = 'ASSIGNED';